import styled from 'styled-components';
import { AgentToolBarStyled } from '../AgentToolBarStyled';

export const AgentToolBarStyledAC = styled(AgentToolBarStyled)`
    background: ${({ theme }) => theme.colors.grey5};
    font-size: ${({ theme }) => theme.fontSizes.h5};
`;
